export const Strings = {
  popup_success_title_default: "Success",
  popup_success_message_add: "Data added successfully",
  popup_success_message_edit: "Data edited successfully",
  popup_success_message_remove: "Data removed successfully",
  popup_error_title: "Error",
  popup_error_title_empty_field: "Required Field Missing",
  popup_error_title_duplicate: "Duplicate Data",
  popup_error_title_search_criteria: "Incomplete Search Criteria",
  popup_error_message_add: "There has been a problem while adding the data",
  popup_error_message_edit: "There has been a problem while editing the data",
  popup_error_message_remove:
    "There has been a problem while removing the data",
  popup_error_message_empty_field: "Please fill up all required fields.",
  popup_error_message_duplicate:
    "There is duplicate data in your entry. Please check and try again.",
  popup_error_message_search_criteria:
    "Select required search criteria to proceed.",
  popup_confirm_save_title: "Save Changes",
  popup_confirm_save_massage: "Are you sure you want to save all the changes?",
  popup_confirm_save_message_with_hours:
    "Changes will take effect in the next hour. Are you sure you want to save all the changes?",
  popup_confirm_cancel_title: "Cancel Changes",
  popup_confirm_cancel_massage:
    "Are you sure you want to cancel all the changes?",
  popup_sms_is_too_long: "SMS Message Template must be 320 characters only",
  popup_app_is_too_long: "App Message Template must be 1000 characters only",
  popup_duplicate_email_message: "This email already exists.",
  popup_number_exists:
    "This number already exists for this agent. Please recheck.",
  popup_error_lockername: "Please select a locker name",
};
